import { render } from "./PageTop.vue?vue&type=template&id=2ae08f4f"
import script from "./PageTop.vue?vue&type=script&lang=js"
export * from "./PageTop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSO\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__